module.exports = __webpack_public_path__ + "img/contract-login-logo.59791363.png";